import * as React from 'react'
import { BaseIconProps } from '../../types'

function SvgIdCard({ size = '24', color = '#666', ...props }: BaseIconProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 14c-1.806 0-3.44.966-4.326 2.491l-.097.176A7.963 7.963 0 0012 20c1.635 0 3.156-.49 4.422-1.332A4.995 4.995 0 0012 16zm0-12a8 8 0 00-5.964 13.332A6.999 6.999 0 0112 14a6.997 6.997 0 015.963 3.332A8 8 0 0012 4zm0 2a3.5 3.5 0 110 7 3.5 3.5 0 010-7zm0 2a1.5 1.5 0 100 3 1.5 1.5 0 000-3z"
        fill={color}
      />
    </svg>
  )
}

export default SvgIdCard
